<template>
  <div class="draggable-design">
    <div v-if="formService.isOutSide" class="layout-draggable" :class="'a_' + initComponent.id" ref="draggable" :options="{group:'draggable'}">
      <div name="list-component">
        <template v-for="component in initComponent.children">
          <div
            class="list-component-item outsideItem"
            v-show="!component.properties.OCHidden"
            :class="[{'list-component-item-select': selectId===component.id}, component.componentType]"
            :key="component.id"
            @click.stop="openAttrForChildren(component)">
            <i class="el-icon-view hidden-outSide-chain"  @click.stop="outSideChainHidden(component)">隐藏</i>
            <component
              ref="childrenComponent"
              :is="component.componentType"
              :initComponent="component"
              :selectId="selectId">
            </component>
          </div>
        </template>
      </div>
    </div>
    <draggable  v-else
                class="layout-draggable"
                :class="'a_' + initComponent.id"
                ref="draggable"
                v-model="initComponent.children"
                :options="{group:'draggable'}">
      <transition-group name="list-component">
        <template v-for="component in initComponent.children">
          <div
            class="list-component-item"
            :class="[{'list-component-item-select': selectId===component.id}, component.componentType]"
            :key="component.id"
            @click.stop="openAttrForChildren(component)">
            <i class="delete-component" v-if="!component.properties.noDelete" @click.stop="removeComponent(component)"></i>
            <i class="collecte-component" @click="copyComponent(component)" v-if="!(component.properties.noDelete || component.componentType==='rc-table')"></i>
            <component
              ref="childrenComponent"
              :is="component.componentType"
              :initComponent="component"
              :selectId="selectId">
            </component>
          </div>
        </template>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import sdk from 'redcatSdk'
import Vue from 'vue'
import _ from 'lodash'
import Draggable from 'vuedraggable'
import interact from 'interactjs'
import {offsetXYFromParentOf} from '../../dragUtil'
import {getProperties} from '@/store/form/componentDefaults.js'
import RcInput from '../input/rc-input.vue'
import RcTable from '../table/rc-table.vue'
import RcNumeric from '../numeric/rc-numeric.vue'
import RcAddress from '../address/rc-address.vue'
import RcPhone from '../phone/rc-phone.vue'
import RcUuid from '../uuid/rc-uuid.vue'
import RcTextarea from '../textarea/rc-textarea.vue'
import RcDate from '../date/rc-date.vue'
import RcCurrency from '../currency/rc-currency.vue'
import RcLabel from '../label/rc-label.vue'
import RcRadio from '../radio/rc-radio.vue'
import RcCheckbox from '../checkbox/rc-checkbox.vue'
import RcRichBox from '../rich-box/rc-rich-box.vue'
import RcCalTime from '../caltime/rc-cal-time.vue'
import RcPassword from '../password/rc-password.vue'
import RcCombobox from '../combobox/rc-combobox.vue'
import RcCoding from '../coding/rc-coding.vue'
import RcFlowingWater from '../flowing-water/rc-flowing-water.vue'
import RcDataSource from '../data-source/rc-data-source.vue'
import RcIdCard from '../idcard/rc-id-card.vue'
import RcChildrenInput from '../input/rc-children-input.vue'
import RcHyperlink from '../hyperlink/rc-hyperlink.vue'
import RcContentTable from '../content-table/rc-content-table.vue'
import RcLoginUser from '../login-user/rc-login-user.vue'
import RcUpload from '../upload/rc-upload.vue'
import RcButton from '../button/rc-button.vue'
import RcMember from '../member/rc-member.vue'
import RcOcr from '../ocr/rc-ocr.vue'
import RcRate from '../rate/rc-rate.vue'
import RcSwitch from '../switch/rc-switch.vue'
import RcReport from '../report/rc-report.vue'
import RcBigFileUpload from '../big-file-upload/rc-big-file-upload.vue'
import RcImage from '../image/rc-image.vue'

const acceptComponent = ['rc-input', 'rc-combobox', 'rc-date', 'rc-numeric', 'rc-textarea', 'rc-table',
  'rc-rich-box', 'rc-coding', 'rc-flowing-water', 'rc-label', 'rc-currency', 'rc-radio', 'rc-checkbox', 'rc-data-source', 'rc-cal-time', 'rc-report', 'rc-hyperlink', 'rc-uuid',
  'rc-id-card', 'rc-login-user', 'rc-phone', 'rc-address', 'rc-password', 'rc-upload', 'rc-button', 'rc-member', 'rc-ocr', 'rc-rate', 'rc-switch', 'rc-big-file-upload', 'rc-image']

export default {
  name: 'rc-draggable',
  inject: ['formService', 'componentEventBus', 'componentCount'],
  props: [ 'initComponent', 'selectId', 'nodeIsCountersign', 'parentComponent' ],
  components: {
    Draggable,
    RcInput,
    RcNumeric,
    RcTable,
    RcAddress,
    RcPhone,
    RcUuid,
    RcTextarea,
    RcDate,
    RcCurrency,
    RcLabel,
    RcRadio,
    RcCheckbox,
    RcRichBox,
    RcCalTime,
    RcPassword,
    RcCombobox,
    RcCoding,
    RcFlowingWater,
    RcDataSource,
    RcIdCard,
    RcChildrenInput,
    RcHyperlink,
    RcLoginUser,
    RcContentTable,
    RcUpload,
    RcButton,
    RcMember,
    RcOcr,
    RcRate,
    RcSwitch,
    RcReport,
    RcBigFileUpload,
    RcImage
  },
  data () {
    let selectComponentId = _.cloneDeep(this.selectId)
    return {
      acceptComponent: [],
      selectComponentId,
      virturlDiv: '',
      index: null,
      page: {
        dragger: {
          dragging: false,
          mouseOffset: {}
        }
      }
    }
  },
  created () {
    this.loadComponent()
  },
  mounted () {
    let _this = this
    _this.virturlDiv = document.createElement('div')
    _this.virturlDiv.id = 'dv1'
    _this.virturlDiv.style.width = '100%'
    _this.virturlDiv.style.borderRadius = 4 + 'px'
    _this.virturlDiv.style.background = '#ECF6FF'
    interact(`.a_${_this.initComponent.id}`).dropzone({
      // only accept elements matching this CSS selector
      accept: '.component-template',
      ondropmove: (event) => {
        // 进入容器中移动动态添加div
        let componentType = event.dragEvent.currentTarget.getAttribute('component-type')
        if (this.acceptComponent.includes(componentType)) {
          let position = offsetXYFromParentOf(event)
          let componentHeights = []
          let components = _this.$refs.draggable.$el.children[0].children

          for (let i = 0, length = components.length; i < length; i++) {
            componentHeights.push(components[i].offsetHeight)
          }
          let index = componentHeights.length ? null : 0
          for (let j = 0, length = componentHeights.length; j < length; j++) {
            let top = componentHeights.slice(0, j).reduce((x, y) => x + y, 0)
            let bottom = top + componentHeights[j]
            if (top < position.y && position.y < bottom) {
              if ((position.y - top) > (componentHeights[j] / 2)) {
                // 放下面
                index = j + 1
              } else {
                // 放上面
                index = j
              }
              break
            }
          }
          _this.removeVirtualDiv(event.target.children[0])
          let height = 40
          switch (componentType) {
            case 'rc-table':
              height = 120
              break
            case 'rc-rich-box':
              height = 300
              break
            case 'rc-textarea':
              height = 80
              break
          }
          _this.virturlDiv.style.height = height + 'px'
          event.target.children[0].insertBefore(_this.virturlDiv, event.target.children[0].children[index])
          _this.index = index
        }
      },
      ondragenter: function (event) {
        // 进入当前容器区域
      },
      ondragleave: function (event) {
        // 离开当前容器区域
        _this.removeVirtualDiv(event.target.children[0])
        _this.index = null
      },
      ondrop: _.debounce((event) => {
        let componentType = event.dragEvent.currentTarget.getAttribute('component-type')
        let componentName = event.dragEvent.currentTarget.getAttribute('component-name')
        if (this.acceptComponent.includes(componentType)) {
          _this.addComponent({componentType, componentName, index: _this.index})
        }
        _this.removeVirtualDiv(event.target.children[0])
        _this.index = null
      })
    })
  },
  methods: {
    loadComponent () {
      sdk.components && sdk.components.DesignArr && sdk.components.DesignArr.forEach(n => {
        Vue.component(
          n.name,
          () => Promise.resolve(n.component)
        )
        if (this.acceptComponent.indexOf(n.componentType) === -1) {
          this.acceptComponent.push(n.componentType)
        }
      })
    },
    removeVirtualDiv (box) {
      if (document.getElementById('dv1')) {
        box.removeChild(this.virturlDiv)
      }
    },
    async addComponent (params) {
      let componentType = params.componentType
      let component = getProperties(componentType)
      if (this.componentCount[componentType]) {
        this.componentCount[componentType] = this.componentCount[componentType] + 1
      } else {
        this.componentCount[componentType] = 1
      }
      if (componentType === 'rc-upload') {
        component.defaults.name = params.componentName
        if (component.defaults.name === '图片选择') {
          component.defaults.properties.listType = 'picture'
        } else {
          component.defaults.properties.listType = 'text'
        }
      }
      component.defaults.properties.count = this.componentCount[componentType]
      component.defaults.name = component.defaults.name + this.componentCount[componentType]
      let pinyin = await this.formService.getPinyinByHanzi(component.defaults.name)
      component.defaults.pinyinName = pinyin.pinyinName
      component.defaults.pinyinFirstChar = pinyin.pinyinFirstChar
      let cm = this.formService.createComponent(component, this.initComponent, params.index)
      this.$nextTick(() => {
        let table = this.formService.schema.getTable(cm.archive.tableId)
        // 表格不需要改列的值
        if (cm.componentType === 'rc-table') {
          table.pinyinName = pinyin.pinyinName
          table.pinyinFirstChar = pinyin.pinyinFirstChar
        } else {
          if (table && table.columns) {
            let c = table.columns.find(c => c.id === cm.archive.columnId)
            if (c) {
              c.pinyinName = pinyin.pinyinName
              c.pinyinFirstChar = pinyin.pinyinFirstChar
            }
          }
        }
      })
    },
    isTableComponent (componentType) {
      return new Promise((resolve, reject) => {
        if (componentType === 'rc-table') {
          this.$confirm('', '你确定要删除吗,全部的子控件也会删除?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'publishMessageBox',
            center: true
          }).then(res => {
            resolve()
          }).catch(() => {
            reject(new Error('取消删除'))
          })
        } else {
          resolve()
        }
      })
    },
    removeComponent (component) {
      this.isTableComponent(component.componentType).then(() => {
        let components = this.initComponent.children.find(m => m.id === component.id)
        // 首先检查要删除的控件是不是有自定义的删除前置事件, 如果有的话, 优先执行前置事件
        let currenComponent = this.$refs.childrenComponent.find(m => m.component === component)
        if (currenComponent && currenComponent.remove) {
          currenComponent.remove()
        }
        this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentList', id: component.id})
        this.formService.removeComponent(components)
      })
    },
    findLastDraggable (index) {
      let parentComponent = null
      if (this.parentComponent.children[this.parentComponent.children.length - index].componentType === 'rc-layout') {
        parentComponent = this.parentComponent.children[this.parentComponent.children.length - index].children[0]
        return parentComponent
      } else if (this.parentComponent.children[this.parentComponent.children.length - index].componentType === 'rc-group' && this.parentComponent.children[this.parentComponent.children.length - index].children.length) {
        parentComponent = this.parentComponent.children[this.parentComponent.children.length - index].children[0].children[0]
        return parentComponent
      } else {
        index++
        return this.findLastDraggable(index)
      }
    },
    async copyComponent (copycomponent) {
      let parentComponent = this.findLastDraggable(1)
      let index = 0
      index = parentComponent.children.length + 1

      let componentType = copycomponent.componentType
      let component = getProperties(componentType)
      if (this.componentCount[componentType]) {
        this.componentCount[componentType] = this.componentCount[componentType] + 1
      } else {
        this.componentCount[componentType] = 1
      }
      if (componentType === 'rc-upload') {
        component.defaults.name = copycomponent.name
        if (component.defaults.name === '图片选择') {
          component.defaults.properties.listType = 'picture'
        } else {
          component.defaults.properties.listType = 'text'
        }
      }
      component.defaults.properties.count = this.componentCount[componentType]
      component.defaults.name = copycomponent.name + '复制'
      let pinyin = await this.formService.getPinyinByHanzi(component.defaults.name)
      component.defaults.pinyinName = pinyin.pinyinName
      component.defaults.pinyinFirstChar = pinyin.pinyinFirstChar
      let cm = this.formService.createComponent(component, parentComponent, index)
      this.$nextTick(() => {
        cm.properties = _.cloneDeep(copycomponent.properties)
        let table = this.formService.schema.getTable(cm.archive.tableId)
        // 表格不需要改列的值
        if (cm.componentType === 'rc-table') {
          table.pinyinName = pinyin.pinyinName
          table.pinyinFirstChar = pinyin.pinyinFirstChar
        } else {
          if (table && table.columns) {
            let c = table.columns.find(c => c.id === cm.archive.columnId)
            if (c) {
              c.pinyinName = pinyin.pinyinName
              c.pinyinFirstChar = pinyin.pinyinFirstChar
            }
          }
        }
      })
    },
    outSideChainHidden (component) {
      component.properties.OCHidden = true
      this.$forceUpdate()
      this.componentEventBus.$emit('outSideChainHidden', {component: component, parentId: this.initComponent.id})
    },
    openAttrForChildren (component) {
      this.componentEventBus.$emit('changeLeftPanel', {state: 'ComponentAttr', id: component.id, save: 2})
      this.selectComponentId = component.id
    }
  },
  watch: {
    'initComponent.children' (val) {
      this.initComponent.properties.childrenSort = val.map(n => n.id)
    },
    nodeIsCountersign: {
      immediate: true,
      handler (val) {
        this.acceptComponent = val ? [] : acceptComponent
      }
    }
  }
}
</script>

<style lang="scss">
  .draggable-design {
    height: 100%;
    .layout-draggable {
      height: 100%;
      background: #F7FBFF;
      > span {
        height: 100%;
        display: block;
        padding-bottom: 50px;
        .sortable-ghost {
          background: #ECF6FF;
        }
      }
    }
    .hidden-outSide-chain{
      font-size: 12px;
      color: #aaa;
      position: absolute;
      right: 0;
      top: 0;
      display: none;
    }
  }
  .outsideItem:hover{
    .hidden-outSide-chain{
      display: block;
    }
  }
  .hidden-outSide-chain:hover{
    color: #54ABF1;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/draggable/rc-draggable.vue